enum IRequestStatus {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  DOWNLOAD = "DOWNLOAD",
  WAIT = "WAIT",
}

export default IRequestStatus;
